import {ref, Ref} from '@vue/composition-api';
type OnCloseCallback = () => void;

interface EditorDialogAlertShowOptions {
	message: string;
	title: string;
	resizable?: boolean;
	width?: number;
	height?: number;
}

const DEFAULT = {
	title: 'no title',
	message: 'no message',
	resizable: false,
	width: 400,
	height: 260,
};
export class EditorDialogAlertStoreControllerClass {
	private static _instance: EditorDialogAlertStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorDialogAlertStoreControllerClass());
	}

	private _displayed!: Ref<boolean>;
	private _title!: Ref<string>;
	private _message!: Ref<string>;
	private _resizable!: Ref<boolean>;
	private _width!: Ref<number>;
	private _height!: Ref<number>;
	private _on_close_callback: OnCloseCallback | undefined;
	private constructor() {}

	init() {
		this._displayed = ref(false);
		this._title = ref(DEFAULT.title);
		this._message = ref(DEFAULT.message);
		this._resizable = ref(DEFAULT.resizable);
		this._width = ref(DEFAULT.width);
		this._height = ref(DEFAULT.height);
	}
	private _reset() {
		this._displayed.value = false;
		this._title.value = DEFAULT.title;
		this._message.value = DEFAULT.message;
		this._resizable.value = DEFAULT.resizable;
		this._width.value = DEFAULT.width;
		this._height.value = DEFAULT.height;
	}

	displayed(): boolean {
		return this._displayed.value;
	}
	title(): string {
		return this._title.value;
	}
	message(): string {
		return this._message.value;
	}
	resizable(): boolean {
		return this._resizable.value;
	}
	width() {
		return this._width.value;
	}
	height() {
		return this._height.value;
	}

	// mutations
	async show(options: EditorDialogAlertShowOptions): Promise<void> {
		return new Promise((resolve, reject) => {
			this._displayed.value = true;
			this._title.value = options.title;
			this._message.value = options.message;
			this._resizable.value = options.resizable || false;
			this._width.value = options.width || DEFAULT.width;
			this._height.value = options.height || DEFAULT.height;
			this._on_close_callback = resolve;
		});
	}
	hide() {
		this._reset();
		if (this._on_close_callback) {
			this._on_close_callback();
		}
	}
}

export const EditorDialogAlertStoreController = EditorDialogAlertStoreControllerClass.instance();
